module.exports = __webpack_public_path__ + "img/linkedin.e2fef8f3.png";